<template>
  <div>
    <div class="w-full max-w-screen-lg">
      <dashboard-header v-if="this.headerOptions[this.currentRoute]" :header="header" :currentLocation="currentLocation" :description="description"/>

      <div class="w-full mt-8">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
import { currentProject, loading } from "@/mixins";
import DashboardHeader from '../components/DashboardHeader'
export default {
  name: "DashboardPage",
  mixins: [ currentProject, loading],
  components: { 
    DashboardHeader
  },
  computed: {
    headerOptions () {
      return {
        Project: {
          header: this.currentProject ? this.currentProject.name : 'Loading...',
          description: 'Here’s how your search is performing...',
          currentLocation: null
        },
        Models: {
          header: 'Your Models',
          description: 'Upload your own custom Tensor Flow models to use for embeddings...',
          currentLocation: 'Models'
        },
        ModelPage: {
          header: this.currentModel ? this.currentModel.name : null,
          description: 'Deploy your model and interact with it...',
          currentLocation: this.currentModel ? this.currentModel.name : null
        },
        Collections: {
          header: 'Your Collections',
          description: 'Collections are sets of data that you want to store and search through...',
          currentLocation: 'Collections'
        },
        CollectionPage: {
          header: this.currentCollection ? this.currentCollection.name : null,
          description: 'Add data to this collection, see how its performing and update settings...',
          currentLocation: this.currentCollection ? this.currentCollection.name : null
        },
        Team: {
          header: 'Your Team',
          description: 'Add other users to this team and see what invites have been sent out...',
          currentLocation: 'Team'
        },
        ProjectSettings: {
          header: 'Project Settings',
          description: 'Update your project’s basic details and settings...',
          currentLocation: 'Settings'
        }
      }
    },
    header () {
      return this.headerOptions[this.currentRoute]  ? this.headerOptions[this.currentRoute].header : 'Loading...'
    },
    description () {
      return this.headerOptions[this.currentRoute] ? this.headerOptions[this.currentRoute].description : 'We are getting your page ready...'
    },
    currentLocation () {
      return this.headerOptions[this.currentRoute] ? this.headerOptions[this.currentRoute].currentLocation : ''
    },
    currentRoute () {
      return this.$route.name;
    }
  },
  
};
</script>
